import { ErrorHandler, inject, provideAppInitializer } from '@angular/core';
import { Router } from '@angular/router';
import * as Sentry from '@sentry/angular';
import { environment } from '../../environments/environment';

const serverErrorsRegex = new RegExp(
  `500 Internal Server Error|401 Unauthorized|403 Forbidden|404 Not Found|502 Bad Gateway|503 Service Unavailable`,
  'mi',
);

export function initializeMonitoring(): void {
  Sentry.init({
    dsn: 'https://6b2f28d1c93d4acd81c1c804579608f7@o1008530.ingest.sentry.io/6239914',
    environment: environment.env,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1.0,
    tracePropagationTargets: ['localhost', /^https:\/\/api.bitappcloud\.com/],
    ignoreErrors: [serverErrorsRegex],
  });
}

export const monitoringProviders = [
  {
    provide: ErrorHandler,
    useValue: Sentry.createErrorHandler({ showDialog: true }),
  },
  {
    provide: Sentry.TraceService,
    deps: [Router],
  },
  provideAppInitializer(() => {
    inject(Sentry.TraceService);
  }),
];
